import { PARTNER_ADDED_FROM, normalizePartnerAddedFrom } from './partnerAddedFrom';
import { PARTNER_SUBSCRIPTION_PATH } from './partnerSubscriptionPlans';

export const resolvePartnerAddedFrom = (partnerProfile) =>
  normalizePartnerAddedFrom(
    partnerProfile?.addedFrom ??
      partnerProfile?.added_from ??
      partnerProfile?.partnerProfile?.addedFrom ??
      partnerProfile?.partnerProfile?.added_from,
  );

/** Manage Subscription is only for partners who joined via the website. */
export const canShowPartnerSubscriptionNav = (partnerProfile) =>
  resolvePartnerAddedFrom(partnerProfile) === PARTNER_ADDED_FROM.WEBSITE;

/**
 * Website partners must have an active currentPlan before using the rest of the portal.
 * Call only after plans have loaded successfully.
 */
export const isPartnerSubscriptionRequired = (partnerProfile, currentPlan) =>
  canShowPartnerSubscriptionNav(partnerProfile) && currentPlan == null;

export const isPartnerSubscriptionPath = (pathname = '') =>
  String(pathname).startsWith(PARTNER_SUBSCRIPTION_PATH);

export { PARTNER_SUBSCRIPTION_PATH };
